/**
 * Discount badge helpers. Always derive the percentage from the same
 * price_incl_tax / final_price_incl_tax pair shown as "vanaf" on listings
 * (parent / cheapest indexed prices), not from a selected configurable variant.
 */
export function hasProductDiscount(priceInclTax: number, finalPriceInclTax: number): boolean {
  return priceInclTax > 0 && finalPriceInclTax > 0 && priceInclTax > finalPriceInclTax;
}

export function getDiscountPercent(priceInclTax: number, finalPriceInclTax: number): string {
  if (!priceInclTax || priceInclTax <= 0 || !finalPriceInclTax || finalPriceInclTax >= priceInclTax) {
    return '0';
  }

  return String(Math.round(((priceInclTax - finalPriceInclTax) / priceInclTax) * 100));
}

export function getProductDiscountPercent(product: Record<string, any>): string {
  const priceInclTax = Number(product?.price_incl_tax);
  const finalPriceInclTax = Number(product?.final_price_incl_tax);

  return getDiscountPercent(priceInclTax, finalPriceInclTax);
}

export function productHasDiscount(product: Record<string, any>): boolean {
  const priceInclTax = Number(product?.price_incl_tax);
  const finalPriceInclTax = Number(product?.final_price_incl_tax);

  return hasProductDiscount(priceInclTax, finalPriceInclTax);
}
